import { sharedPoll, stopPoll } from '@/command/poll'
import { useEffect, useState } from 'react'
import { releasesApi, type ReleaseAlert } from '@/api/releases'

const TITLES: Record<string, string> = { auto_summary: 'סיכום תור הלילה האוטומטי', failed_run: 'ריצת שחרור נכשלה', no_sync: 'אין סנכרון מעל שעתיים', missed_merge: 'לא רץ מיזוג עבור PRs מאושרים', monitor_unavailable: 'בדיקת השחרורים לא זמינה' }
export function ReleaseAlerts({ alerts }: { alerts: ReleaseAlert[] }) {
  if (!alerts.length) return null
  return <section aria-label="התראות שחרורים" role="alert" className="mb-5 space-y-3 rounded-xl border border-red-500/50 bg-red-950/40 p-4 text-right" dir="rtl">
    <h2 className="font-semibold text-red-200">התראות שחרורים</h2>
    {alerts.map(alert => <article key={alert.id} className="border-t border-red-500/20 pt-3 text-sm text-red-200">
      <strong>{alert.repo} · {TITLES[alert.kind] ?? alert.kind}</strong>
      <p className="mt-1">{alert.message}</p>
      {alert.notification_error && <p className="mt-1">שליחת WhatsApp לא אושרה: {alert.notification_error}</p>}
      {alert.run_url && /^https:\/\/github\.com\/the-Otomator\//.test(alert.run_url) && <a href={alert.run_url} target="_blank" rel="noreferrer" className="mt-2 inline-block underline">לריצה ב־GitHub</a>}
    </article>)}
  </section>
}
export function MonitorReleaseAlerts() {
  const [alerts, setAlerts] = useState<ReleaseAlert[]>([])
  const [error, setError] = useState(false)
  useEffect(() => {
    let live = true
    const load = async () => { try { const result = await releasesApi.list(); if (live) { setAlerts(result.alerts ?? []); setError(false) } } catch { if (live) setError(true); return false } }
    const timer = sharedPoll(load, 30_000, true)
    return () => { live = false; stopPoll(timer) }
  }, [])
  return <>{error && <p role="alert" className="mb-4 rounded border border-red-500/50 p-3 text-red-300">לא ניתן לטעון התראות שחרורים.</p>}<ReleaseAlerts alerts={alerts} /></>
}
